import { render, staticRenderFns } from "./viewTicket.vue?vue&type=template&id=d252b20e&"
import script from "./viewTicket.vue?vue&type=script&lang=js&"
export * from "./viewTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports